import * as React from 'react'

import { cn } from '@/lib/utils'

interface CheckboxProps extends React.ComponentProps<'input'> {
  label?: string
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, type, label, ...props }, ref) => {
    return (
      <div className='flex items-center mt-1'>
        <input type='checkbox' className={cn(className)} ref={ref} {...props} />
        {label && <label className='block text-sm font-medium ms-2'>{label}</label>}
      </div>
    )
  }
)
Checkbox.displayName = 'Input'

export { Checkbox }
